import React from 'react';
import { Badge } from '../ui/badge';
import FAQItem from '../cards/FAQItem';
import { mockData } from '../../mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 px-6 bg-[#111111]">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <Badge className="inline-flex items-center justify-center px-4 py-1.5 bg-gradient-to-r from-[#2F6BFF]/10 to-[#4DA3FF]/10 text-[#2F6BFF] border border-[#2F6BFF]/20 rounded-full text-sm font-medium mb-6 hover:from-[#2F6BFF]/20 hover:to-[#4DA3FF]/20 transition-all duration-300">
            FAQ
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Common Questions</h2>
          <p className="text-[#9AA3B2] text-lg">Everything you need to know about working with MeshWeb</p>
        </div>
        <div className="space-y-4">
          {mockData.faq.map((item) => (
            <FAQItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
